'use strict';

var $ = require('jquery');

window.initMap = function(){
	var $retailersMap = $('#retailer-map');
	if($retailersMap.length){
		new RetailersMap($retailersMap.get(0));
	}
}


class RetailersMap{

	constructor(mapContainer){
		var that = this;

		that.mapContainer = mapContainer;
		that.retailersMap = false;

		that.mapContainer.addEventListener('drawMap', function(e){
			that.drawMap( e.detail );
		});

		// User location button
		$(mapContainer).siblings('#retailers-list').find('.user-location-button').click(function () {
			that.getUserPosition();
			$('button.retailer-toggle').removeClass('open');
			$('section.retailer-details').slideUp('fast');
		});

		// Init map on Helsinki
		that.mapContainer.dispatchEvent(new CustomEvent('drawMap', { detail: {'lat': 60.192059, 'lng': 24.945831} }));
	}


	getUserPosition(){
		var that = this;
		var userCoords = localStorage.getItem('userCoords');

		if (userCoords && userCoords !== 'false') {
			// Use predefined position if set to localStorage
			userCoords = JSON.parse(userCoords);
			userCoords = {
				'lat': parseFloat(userCoords.lat),
				'lng': parseFloat(userCoords.lng)
			}
			var event = new CustomEvent('drawMap', { detail: userCoords });

			that.mapContainer.dispatchEvent(event);
		} else {
			navigator.geolocation.getCurrentPosition(function(pos){ 
				// Use geolocated coordinates
				userCoords = {
					'lat': parseFloat(pos.coords.latitude),
					'lng': parseFloat(pos.coords.longitude)
				};
				localStorage.setItem('userCoords', JSON.stringify(userCoords) );
				var event = new CustomEvent('drawMap', { detail: userCoords });
				that.mapContainer.dispatchEvent(event);
			},
			function () {
				// On failure revert to default
				localStorage.setItem('userCoords', false );
				var event = new CustomEvent('drawMap', { detail: false });
				that.mapContainer.dispatchEvent(event);
			}, {timeout: 5000});
		}
	}


	drawMap(userCoords) {
		if(userCoords) {
			var center = {lat: userCoords.lat, lng: userCoords.lng};
			var zoom = 10;
		} else {
			var center = {lat:60.192059, lng: 24.945831};
			var zoom = 10;
		}

		this.retailersMap = new google.maps.Map(this.mapContainer, {
			center: center,
			zoom: zoom,
			minZoom: 1,
			maxZoom: 16,
			disableDefaultUI: true,
            zoomControl: true,
            fullscreenControl: true,
            styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#999999"}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"visibility":"simplified"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry.fill","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape.natural.terrain","elementType":"labels.text","stylers":[{"visibility":"off"},{"invert_lightness":true}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.medical","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.place_of_worship","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.school","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.sports_complex","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45},{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#babcbe"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.highway.controlled_access","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#babcbe"}]},{"featureType":"road.highway.controlled_access","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#babcbe"}]},{"featureType":"road.arterial","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#babcbe"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.airport","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.bus","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.rail","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"color":"#aab9bf"}]}]
		});

		this.addMapEvents();
		this.initRetailers();
	}


	initRetailers () {
		var that = this;

		that.retailMarkers = [];
        that.retailers = $('.retailers-list .retailer');
        
		that.retailers.each(function(index, elem) {
			var listItem = this;

			// Check that there are coordinates for this retailer
			if ($(listItem).data('coords') === '') {
				return;
			}

			// Get Coordinates from the element
			var coords = $(listItem).data('coords').split(',').map(function(item) {
				return parseFloat(item.trim());
			});

			// Check that coordinates were added to the variable
            if (coords.length < 2) {
				return;
			}

			var address = $(listItem).data('address'),
				info = $(listItem).data('info'),
				name = $(listItem).data('name'),
            	retailerType = $(listItem).data('type');
            
            // Default marker color to the Service type
            var markerColor = '#52b9e9';
            if (retailerType.includes('sales')) {
                markerColor = '#cf0072';
            }
 
			// InfoWindow content
			var infowindow = new google.maps.InfoWindow({
				content: '<p class="marker-headline">'+name+'</p><br>' +
				'<p class="address">' + address + '</p><br>' +
				'<p class="information">' + info + '</p><br>',
				maxWidth: 280
			});

			// Create marker for the retailer
			var marker = new google.maps.Marker({
				position: { lat: coords[0], lng: coords[1] },
				map: that.retailersMap,
				draggable: false,
				animation: google.maps.Animation.DROP,
				icon: {
					path: 'M180.84,90.42C180.84,40.48,140.36,0,90.42,0S0,40.48,0,90.42c0,12.62,2.59,24.63,7.25,35.54H7.19l83.22,213.95,l83.16-213.95h0C178.25,115.05,180.84,103.03,180.84,90.42z',
					fillColor: markerColor,
					fillOpacity: 1,
					strokeWeight: 0,
					scale: 0.15,
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point((180.84/2), 339.91)
				},
			});


			that.retailMarkers.push(marker);


			// Handle list item click 
			$(listItem).find('.retailer-toggle').off("click").click(function() {
				// Toggle open the list item
				$(this).toggleClass('open').siblings('.retailer-details').slideToggle('fast');
				
				if ($(this).hasClass('open')) {
					// Also open the infowindow
					infowindow.open(that.retailersMap, marker);
					that.retailersMap.panTo(marker.getPosition());
				} else {
					infowindow.close();
				}
			});


			// Handle marker click
			marker.addListener('click', function() {
				that.retailersMap.panTo(marker.getPosition());
				// Check if InfoWindow is closed
				if (!infowindow.getMap()) {
					infowindow.open(that.retailersMap, marker);
					
					// Also open the list item
					if (!$(listItem).find('.retailer-toggle').hasClass('open')) {
						$(listItem).find('.retailer-toggle').click();
					}
				} else {
					infowindow.close();
					if ($(listItem).find('.retailer-toggle').hasClass('open')) {
						$(listItem).find('.retailer-toggle').click();
					}
				}
			});

			// Handle infowindow close button click
			infowindow.addListener('closeclick', function() {
				if ($(listItem).find('.retailer-toggle').hasClass('open')) {
					$(listItem).find('.retailer-toggle').click();
				}
			});
		});
	}

	addMapEvents () {
		var that = this;

		that.retailersMap.addListener('idle', function(){
			that.updateLocalRetailList();
			return;
		});


		$('.retailer-search .address-input').on('blur keyup', function(e){
			if(e.type === 'keyup'){
				if(e.keyCode === 13){
					that.updateCurrentAddress($(this).val());
				}
			}else if(e.type === 'blur'){
				that.updateCurrentAddress($(this).val());
			}
		});
	}
	updateLocalRetailList () {
		var that = this;

		var bounds = this.retailersMap.getBounds();

		this.retailers.each(function(index, el){
			var retail = $(this);

			if ($(this).data('coords') === '') {
				return;
			}

			var retailCoords = $(this).data('coords').split(',').map(function(item) {
				return parseFloat(item.trim());
			});

			// Check that coordinates were added to the variable
            if (retailCoords.length < 2) {
				return;
			}
			

			var retailInMap = bounds.contains({ lat: retailCoords[0], lng: retailCoords[1] });

			if(retailInMap){
				retail.addClass('visible');

			}else{
				retail.removeClass('visible');
			}
		});
		that.updateFoundRetailersCount(that.retailers.filter('.visible').length);
	}


	updateCurrentAddress(address){
		var that = this;
		var geocoder = new google.maps.Geocoder();

		geocoder.geocode({address: address}, function(results, status){
			if (status == 'OK') {
				that.retailersMap.panTo(results[0].geometry.location);
				that.retailersMap.fitBounds(results[0].geometry.viewport);
			}
		});
	}
	updateFoundRetailersCount (count) {
		if (count > 0) {
			$('.address-results').text(count + ' Jälleenmyyjä'+ (count > 1 ? 'ä' : '' )+' löytynyt').show();
			$('.retailers-header .type-display').removeClass('empty');		
		} else {
			$('.address-results').text(' ');
			$('.retailers-header .type-display').addClass('empty');
		}
	}
}

